import instance from "../../axios/axios-user";
import { API_PATHS } from "../api_paths";

const searchCollaborators = (payload: { query: string }) => {
  return instance(API_PATHS.global.searchCollaborators, {
    params: { ...payload, type: "omit" },
  });
};

export const GLOBAL = {
  searchCollaborators,
};
